import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_URL = `${API_URL}/admin`;
const API_URL_DEVICE = `${API_URL}/devices`;


export const getDevices = async (token, company) => {
  try {
    const url = company
      ? `${API_URL_DEVICE}?company=${encodeURIComponent(company)}`
      : `${API_URL_DEVICE}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log("Received devices:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};



/*
export const getDevices = async (token) => {
  try {
    const response = await axios.get(`${API_URL_DEVICE}`, {
      headers: {
        "Authorization": `Bearer ${token}`, 
        "Content-Type": "application/json"
      }
    });

    console.log("Received devices:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};*/




export const getAllDevices = async (token) => {
  try {
    const response = await axios.get(`${ADMIN_URL}/devices`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
      }
    );
  return response.data;
  } catch (error) {
    console.error("Error fetching all devices:", error);
    throw error;
  }
  }



export const getAllCompanies = async (token) => {
  try {
    const response = await axios.get(`${ADMIN_URL}/companies`, {
      headers: {
        "Authorization": `Bearer ${token}`, 
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching companies:", error);
    throw error;
  }
};
